import { NativeModules, Platform } from 'react-native';
import { currentIP, ASSAABLOY, DORMAKABA, SALTO } from '../../config/Constant';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const initializeDoorKey = (doorKeyType) => {
    
    return async (dispatch, getState) => {
        
        const { DormakabaPlugin, AssaAbloyPlugin, SaltoPlugin } = NativeModules;
        const { currentGuestDetails } = getState().guestDetailsSlice;
        const { isLoggedIn, fcmToken } = getState().appConfigSlice;

        const sessionToken = await AsyncStorage.getItem("sessionToken")

        console.log("in initializing door key: ",doorKeyType, fcmToken);

        if(!isLoggedIn){
            console.log("not logged in, not initializing door key");
            return;
        }
        

        if (doorKeyType == DORMAKABA && DormakabaPlugin) {
            if (Platform.OS == "android") {
                DormakabaPlugin.initializePlugin();
                return;
            }

            return;
        }

        if (fcmToken) {
            if (doorKeyType == ASSAABLOY && AssaAbloyPlugin) {
                AssaAbloyPlugin.initializePlugin(currentIP, sessionToken, currentGuestDetails.reservationNumber, fcmToken, (status) => console.log("initialize door key status: ", status));
                return;
            }
        }
        
        if (doorKeyType == SALTO && SaltoPlugin) {
            SaltoPlugin.initializePlugin(currentIP, sessionToken, currentGuestDetails.reservationNumber, (status) => console.log("initialize door key status: ", status));
        }
    }
}